
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import PushNotificationsTypesListView from "./push_notifications_types-list.html";
import PushNotificationsTypesEditView from "./push_notifications_types-edit.html";

angular.module("push_notifications_types", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('push_notifications_types', {
                url: "/push_notifications_types",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('push_notifications_types.list', {
                url: "/list",
                controller: "PushNotificationsTypesListCtrl",
                template: PushNotificationsTypesListView,
                // requiredPermission: ["MAILINGS_READ"]
            })
            .state('push_notifications_types.edit', {
                url: "/edit/:id",
                controller: "PushNotificationsTypesEditCtrl",
                template: PushNotificationsTypesEditView,
                // requiredPermission: ["MAILINGS_READ"]
            })
    }])
    ;